import { FileWithPath } from "react-dropzone";

export enum FileCategory {
  FLOORPLAN = 'floorplan',
  SLIDER = 'slider',
  LOCATION = 'location',
  COUNTRY = 'country',
  CITY = 'city',
  NEIGHBORHOOD = 'neighborhood',
  PARTNER_LOGO = 'partner-logo',
  EDUCATION_MATERIAL = 'education-material',
  EDUCATION_MATERIAL_THUMBNAIL = 'education-material-thumbnail',
  DATA_ROOM_IMAGE = 'data-room-image',
  RISK_MIGRATION_IMAGE = 'risk-migration-image',
  ABOUT_PARTNER_IMAGE = 'about-partner-image',
  ROLES_AND_RESPONSIBILITIES_IMAGE = 'roles-and-responsentials-image',

  INVESTMENT_STRATEGY_CRALRIFY_MEDIA = 'investment-strategy-clarify-media',
  TEASER_SUMMARY_CRALRIFY_MEDIA = 'teaser-summary-clarify-media',
  OPPORTUNITY_SUMMARY_CRALRIFY_MEDIA = 'opportunity-summary-clarify-media',
  OPPORTUNITY_DETAILS_CRALRIFY_MEDIA = 'opportunity-details-clarify-media',
  ABOUT_OPPORTUNITY_CRALRIFY_MEDIA = 'about-opportunity-clarify-media',
  PARTNER_CRALRIFY_MEDIA = 'partner-clarify-media',
  LOCATION_CRALRIFY_MEDIA = 'location-clarify-media',
  RISK_CRALRIFY_MEDIA = 'risk-clarify-media',
  ROLES_CRALRIFY_MEDIA = 'roles-clarify-media',
  SECURITY_INFORMATION_CRALRIFY_MEDIA = 'security-information-clarify-media',
  DATA_ROOM_CRALRIFY_MEDIA = 'data-room-clarify-media',
  INVESTOR_REPORT_CRALRIFY_MEDIA = 'investor-report-clarify-media',
  EDUCATION_AND_RESEARCH = 'education-and-research',
  DISCLAIMER_CRALRIFY_MEDIA = 'disclaimer-clarify-media',
  ADDITIONAL_MATERIALS_CRALRIFY_MEDIA = 'additional-materials-clarify-media',
  HEADER_CRALRIFY_MEDIA = 'header-clarify-media',
}

export interface DroppedFile extends FileWithPath {
  preview: string,
  category?: FileCategory
}